<aims-common-table id="fyPayRates-table" [dataSource]="fyPayRates | async" [header]="fyPayRatesHeader" [pageSize]="10"
  [permissions]="tablePermissions" [addRowInitialObject]="initialTableElement" (rowUpdated)="handleRowUpdate($event)"
  (rowAdded)="handleRowAdd($event)">

  <ng-template aimsCommonTableDynamicToolbar>
    <button mat-raised-button color="basic" (click)="addFyRecords()" type="button">
      <i class="fas fa-plus"></i>
      Add new Fiscal Year pay records
    </button>
  </ng-template>

  <aims-common-table-dynamic-row id="jobTitleId">
    <ng-template viewMode let-element>{{ element.jobTitleId |
      getText:'jobTitleId':'jobTitleAndWs':jobTitlesUnionValues |
      async}}
    </ng-template>
    <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
      <mat-form-field appearance="fill" class="top10 fullWidth">
        <mat-label>JobTitle - WorkSection</mat-label>
        <mat-select [formControl]="dynamicControl">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of jobTitlesUnionValues | async" [value]="val.jobTitleId">
            {{val.jobTitleAndWs}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill"class="top20 fullWidth">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of jobTitlesUnionValues | async" [value]="val.jobTitleId">
            {{val.jobTitleAndWs}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

  <aims-common-table-dynamic-row id="payRate">
    <ng-template viewMode let-element>
      {{element.payRate | currency}}
    </ng-template>
    <ng-template editMode let-dynamicControl="dynamicControl">
      <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" [formControl]="dynamicControl">
      </aims-numeric>
    </ng-template>
  </aims-common-table-dynamic-row>

  <aims-common-table-dynamic-row id="pmmApprovedById">
    <ng-template viewMode let-element>{{ element.pmmApprovedById |
      getText:'employeeId':'fullName':employeeValues}}
    </ng-template>
    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" class="top20 fullWidth">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of employeeValues" [value]="val.employeeId">
            {{val.fullName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

  <aims-common-table-dynamic-row id="hrmApprovedById">
    <ng-template viewMode let-element>{{ element.hrmApprovedById |
      getText:'employeeId':'fullName':employeeValues}}
    </ng-template>
    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" class="top20 fullWidth">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of employeeValues" [value]="val.employeeId">
            {{val.fullName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

</aims-common-table>
